import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import { AppModule } from './app/app.module';
import { CookieService } from '@nbg-globals/cookie';

if (process.env.ENV === 'production') {
	enableProdMode();
}

/*
 * In short these packages contain angular features which make getting an Angular app
 * up and running possible in the browser. Bootstrapping is essential and one of those
 * features.
 * */
platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.then(() => CookieService.initCookieScripts())
	// Without this a failed bootstrap is silent: the page sits on the static loader forever.
	.catch(err => console.error('[bootstrap] AppModule failed to bootstrap:', err));
